export default __webpack_public_path__ + "static/media/illustration.4993602b.svg";